import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { StationsState } from '../../types';

import { getSelectedStation } from '../operations/getSelectedStation';

import { STATUS_LOADING } from 'common/constants';

export const setSelectedStation = (builder: ActionReducerMapBuilder<StationsState>) => builder
  .addCase(getSelectedStation.pending, (state) => {
    state.selectedStation.loadingStatus = STATUS_LOADING.load;
  })
  .addCase(getSelectedStation.fulfilled, (state, { payload }) => {
    state.selectedStation.loadingStatus = STATUS_LOADING.done;
    state.selectedStation.data = payload;
  })
  .addCase(getSelectedStation.rejected, (state, { meta }) => {
    if (meta.aborted) {
      state.selectedStation.loadingStatus = STATUS_LOADING.abort;
    } else {
      state.selectedStation.loadingStatus = STATUS_LOADING.error;
    }
    state.selectedStation.data = undefined;
  });
